import { computed, ref } from 'vue'
import mr from './mr.json'

/**
 * English and Marathi for the admin (owner, 2026-10-27). Texts are written
 * in English in the code; `tr()` looks the sentence up in mr.json when
 * Marathi is chosen, and falls back to the English. Placeholders like
 * {name} are filled from `params`. Remembered on this browser.
 */
export type Language = 'en' | 'mr'

const KEY = 'devi-admin-lang'
const MARATHI = mr as Record<string, string>

function saved(): Language {
  try {
    return localStorage.getItem(KEY) === 'mr' ? 'mr' : 'en'
  } catch {
    return 'en'
  }
}

export const language = ref<Language>(saved())

export function tr(
  text: string | null | undefined,
  params: Record<string, string | number | null | undefined> = {},
): string {
  if (text === null || text === undefined) return ''
  const chosen = language.value === 'mr' ? (MARATHI[text] ?? text) : text
  return chosen.replace(/\{(\w+)\}/g, (all, name: string) => (name in params ? String(params[name] ?? '') : all))
}

export function setLanguage(next: Language): void {
  language.value = next
  try {
    localStorage.setItem(KEY, next)
  } catch {
    // Private browsing: the choice lasts until the page is closed.
  }
  document.documentElement.lang = next === 'mr' ? 'mr-IN' : 'en-IN'
}

export function useLanguage() {
  return { language, isMarathi: computed(() => language.value === 'mr'), tr, setLanguage }
}

/** Locale for dates: Marathi month names with the usual 0–9 digits. */
export function dateLocale(): string {
  return language.value === 'mr' ? 'mr-IN-u-nu-latn' : 'en-IN'
}
